// import { SpeakerQuestion } from "./speaker-question";
import { Participant } from "./participant";

export class AgendaSpeaker
{
    id: number;
    agenda_id: number;
    participant_id: number;
    participant: Participant;
    external_link: string;
    name: string;
    position: string;
    image_url: string;
    // causing bug with circular dependency
    //questions: SpeakerQuestion[] = [];
    selected: boolean = false;
    removed: boolean = false;
    index: number;

    /**
     * constructor
     *
     * @param {AgendaSpeaker} init
     */
    public constructor(init?: AgendaSpeaker)
    {
        if (!!init)
        {
            Object.assign(this, init);

            if (init.participant) {
                this.participant = new Participant(init.participant);
            }

            // causing bug with circular dependency
            // if (init.questions) {
            //     this.questions = [];
            //     init.questions.forEach(question => {
            //         this.questions.push(new SpeakerQuestion(question));
            //     });
            // }
        }
    }

}
